import { AxiosInstance } from "axios"

export interface CreateStripeAccountLinkRequest {
  /** One of the `action` values returned by the account-options API. */
  action: string
}

export interface CreateStripeAccountLinkResponse {
  time: string
  apiStatus: string
  data?: {
    action: string
    linkType: string
    url: string
  }
  errorCode?: number
  errorMsg?: string
}

/** Returns a Stripe-hosted link for the requested account action. */
export function createStripeAccountLinkApi(
  data: CreateStripeAccountLinkRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "post",
    url: "/agent/stripe/account-link",
    data,
  }) as Promise<{ data: CreateStripeAccountLinkResponse }>
}
